import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

const modulesFiles = require.context('./modules', true, /\.js$/)


const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        badge: {},
        plannerList: [],
        messagesLists: [],
        totalMessages: [],
        badgeCount: 0,
        totalMessgeNumber: 0
    },
    actions: {
        /**
         * 修改指定徽章的值
         * @param context 上下文
         * @param payload 参数
         * @returns {Promise<unknown>}
         */
        updateBadge(context, payload) {
            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                //向指定徽章
                context.commit('updateBadge', payload)
                resolve()
            })
        }
    },
    mutations: {

        /**
         * 创建徽章的值
         * @param state 状态
         * @param payload 参数
         */
        addBadge(state, payload) {
            //如果徽章里面没有该徽章的值，则通知VUE创建他
            if (payload) {
                //获取key
                let badge = state.badge;
                for (let key in payload) {
                    //设置key值
                    badge[key] = payload[key]
                }
                //删掉key
                Vue.delete(state, 'badge');
                //重置key
                Vue.set(state, 'badge', badge)
            }
        },
        /**
         * 修改指定徽章的值
         * @param state 状态
         * @param payload 参数
         */
        updateBadge(state, payload) {
            if (payload) {
                for (let key in payload) {
                    state.badge[key] = payload[key]
                }
            }
        },
        SAVE_MESSAGE: (state, list, total) => {
            state.messagesLists = list
            state.totalMessgeNumber = total
        },
        UPDATE_MESSAGE: (state, list, total) => {
            state.totalMessages = list
            state.totalMessgeNumber = total

        },
        UPDATE_BADGE: (state, count) => {
            state.badgeCount = parseInt(count)
        }
    },
    modules,
    getters
})

export default store


